import { gql } from "@apollo/client";
import { Button } from "components/buttons/button";
import { Form } from "components/Form";
import { FormSubmit } from "components/Form/FormSubmit";
import { Input } from "components/Form/Input";
import { useGetVoucherReportLazyQuery } from "lib/graphql-generated";
import { z } from "zod";
import Papa from "papaparse";

const schema = z.object({
  startDate: z.date(),
  endDate: z.date(),
});

type Schema = z.infer<typeof schema>;

export const GenerateVoucherReportForm = () => {
  const [getReport] = useGetVoucherReportLazyQuery();

  const handleSubmit = async (values: Schema) => {
    const { startDate, endDate } = values;

    getReport({
      variables: {
        startDate: startDate.toISOString().split("T")[0],
        endDate: endDate.toISOString().split("T")[0],
      },
      onCompleted(data) {
        if (data && data.vouchers) {
          let csvData = data.vouchers.map((v) => ({
            date: v.created_at.split("T")[0],
            amount: v.initial_amount / 100,
          }));

          csvData.push({
            date: "Total",
            amount: csvData.reduce((acc, curr) => acc + curr.amount, 0),
          });

          const csv = Papa.unparse(csvData, {});
          const blob = new Blob([csv], { type: "text/csv" });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.setAttribute("hidden", "");
          a.setAttribute("href", url);
          a.setAttribute("download", "report.csv");
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      },
    });
  };

  return (
    <>
      <Form
        schema={schema}
        onSubmit={handleSubmit}
        className='border-t grid grid-cols-1 md:grid-cols-2 gap-4 py-4'>
        <h2 className='font-header text-2xl col-span-full'>Voucher Report</h2>
        <div className=''>
          <Input label='Start Date' name='startDate' type='date' />
        </div>
        <div className=''>
          <Input label='End Date' name='endDate' type='date' />
        </div>
        <div className='flex justify-end col-span-full'>
          <FormSubmit className='border rounded-md px-2 py-1 text-sm bg-yellow-500 hover:border-black disabled:bg-gray-200 disabled:cursor-not-allowed'>
            Generate Report
          </FormSubmit>
        </div>
      </Form>
    </>
  );
};
